import { render, staticRenderFns } from "./BaseRadioInput.vue?vue&type=template&id=7a13ac36"
import script from "./BaseRadioInput.vue?vue&type=script&lang=js"
export * from "./BaseRadioInput.vue?vue&type=script&lang=js"
import style0 from "./BaseRadioInput.vue?vue&type=style&index=0&id=7a13ac36&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports